webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-984367b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Memo__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Memo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Memo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_HouseholdAccountBook__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_HouseholdAccountBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_HouseholdAccountBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Health__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Health___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Health__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_KPT__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_KPT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_KPT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_VideoPlayer__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_VideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_VideoPlayer__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/memo',
    name: 'Memo',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Memo___default.a
  }, {
    path: '/health',
    name: 'Health',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Health___default.a
  }, {
    path: '/house',
    name: 'HouseholdAccountBook',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_HouseholdAccountBook___default.a
  }, {
    path: '/kpt',
    name: 'KPT',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_KPT___default.a
  }, {
    path: '/video-player',
    name: 'VideoPlayer',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_VideoPlayer___default.a
  }]
}));

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var CalcChart = function () {
  function CalcChart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CalcChart);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CalcChart, [{
    key: 'checkObjectValueExist',
    value: function checkObjectValueExist(arr, key, val) {
      return arr.some(function (arrVal) {
        return val === arrVal[key];
      });
    }
  }, {
    key: 'setDayObj',
    value: function setDayObj(data) {
      var obj = {};
      for (var key in data) {
        var dates = data[key].date;
        var date = dates.split('-');
        if (date[0] in obj) {
          if (!this.checkObjectValueExist(obj[date[0]], 'date', date[1])) {
            obj[date[0]].push({
              date: date[1],
              value: date[0] + '-' + date[1]
            });
          }
        } else {
          obj[date[0]] = [{
            date: date[1],
            value: date[0] + '-' + date[1]
          }];
        }
      }
      return obj;
    }
  }, {
    key: 'sortFunc',
    value: function sortFunc(arr) {
      arr.sort(function (a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
      return arr;
    }
  }, {
    key: 'validDate',
    value: function validDate(y, m, d) {
      var dt = new Date(y, m - 1, d);
      return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
    }
  }, {
    key: 'getAllDay',
    value: function getAllDay(startDay, endDay) {
      var result = [];
      var start = startDay.slice(0, 7) + '-01';
      var endDate = [endDay.slice(0, 4), endDay.slice(5, 7)];
      var end = null;
      if (this.validDate(Number(endDate[0]), Number(endDate[1]), 31)) {
        end = endDay.slice(0, 7) + '-31';
      } else if (this.validDate(Number(endDate[0]), Number(endDate[1]), 30)) {
        end = endDay.slice(0, 7) + '-30';
      } else if (this.validDate(Number(endDate[0]), Number(endDate[1]), 29)) {
        end = endDay.slice(0, 7) + '-29';
      } else {
        end = endDay.slice(0, 7) + '-28';
      }
      var inputObj = {
        year: Number(start.slice(0, 4)),
        month: Number(start.slice(5, 7)),
        day: Number(start.slice(8, 10))
      };
      var endObj = {
        year: Number(end.slice(0, 4)),
        month: Number(end.slice(5, 7)),
        day: Number(end.slice(8, 10))
      };
      var dateFlag = true;
      while (dateFlag) {
        if (this.validDate(inputObj.year, inputObj.month, inputObj.day)) {
          result.push(this.getDateString(inputObj.year, inputObj.month, inputObj.day));
          inputObj.day++;
        } else {
          if (this.validDate(inputObj.year, inputObj.month + 1, 1)) {
            result.push(this.getDateString(inputObj.year, inputObj.month + 1, 1));
            inputObj.month++;
            inputObj.day = 2;
          } else if (this.validDate(inputObj.year + 1, 1, 1)) {
            result.push(this.getDateString(inputObj.year + 1, 1, 1));
            inputObj.year++;
            inputObj.month = 1;
            inputObj.day = 2;
          }
        }
        var input = new Date(inputObj.year, inputObj.month, inputObj.day);
        var _end = new Date(endObj.year, endObj.month, endObj.day);
        if (input > _end) {
          dateFlag = false;
        }
      }
      return result;
    }
  }, {
    key: 'getDateString',
    value: function getDateString(year, month, day) {
      return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
  }]);

  return CalcChart;
}();

/* harmony default export */ __webpack_exports__["a"] = (CalcChart);

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(74);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Doughnut */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(74);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* HorizontalBar */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(74);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Line */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_video_player__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebaseEnv_json__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebaseEnv_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__firebaseEnv_json__);












__WEBPACK_IMPORTED_MODULE_7_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_8__firebaseEnv_json___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_video_player___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_firebase___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



window.videojs = __webpack_require__(242);
__webpack_require__(100);
var languages = __webpack_require__(523);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },

  methods: {
    initialize: function initialize() {
      var self = this;
      this.player = null;

      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        start: 0,
        playsinline: false,
        customEventName: 'statechanged',

        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5', 'flash'],
        playbackRates: [],
        plugins: {}
      }, this.options);

      var language = videoOptions.language;
      videojs.addLanguage(language, languages[language]);

      var playsinline = videoOptions.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(videoOptions.customEventName, values);
        }
      };

      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }
      this.player = videojs(this.$el.children[0], videoOptions, function () {
        self.$emit('ready', self.player);

        this.on('loadeddata', function () {
          this.muted(videoOptions.muted);
          if (!!videoOptions.start) {
            this.currentTime(videoOptions.start);
          }
          emitPlayerState('loadeddata', true);
        });

        this.on('canplay', function () {
          emitPlayerState('canplay', true);
        });

        this.on('canplaythrough', function () {
          emitPlayerState('canplaythrough', true);
        });

        this.on('play', function () {
          emitPlayerState('play', true);
        });

        this.on('pause', function () {
          emitPlayerState('pause', true);
        });

        this.on('waiting', function () {
          emitPlayerState('waiting', true);
        });

        this.on('playing', function () {
          emitPlayerState('playing', true);
        });

        this.on('ended', function () {
          emitPlayerState('ended', true);
        });

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        this.player.pause && this.player.pause();
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js vjs-custom-skin';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_menu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    VueMenu: __WEBPACK_IMPORTED_MODULE_0__components_menu___default.a
  },
  data: function data() {
    return {
      auth: null,
      menuVisible: false,
      loginState: false,
      message: 'test comment',
      showSnackbar: false,
      snackbarColor: 'cyan darken-2',
      snackbarMessage: '',
      snackbarTimeout: 3000,
      position: 'center',
      duration: 4000
    };
  },
  methods: {
    showLoginModal: function showLoginModal() {
      this.$refs.modal.modalControl(true);
    },
    closeModal: function closeModal(state) {
      this.$refs.modal.modalControl(false);
    },
    setSnackbar: function setSnackbar(type, msg) {
      this.snackbarMessage = msg;
      this.snackbarColor = type === 'success' ? 'cyan darken-2' : 'pink accent-2';
      this.showSnackbar = true;
    }
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homebookChart__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homebookChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__homebookChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_CostInput__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_CostInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__parts_CostInput__);








var typeTable = {
  'utility': '光熱費',
  'foods': '食費',
  'Sundries': '雑貨',
  'rent': '家賃'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableSearch',
  data: function data() {
    return {
      headers: [{
        text: '日付',
        aligh: 'right',
        sortale: true,
        value: 'date'
      }, {
        text: '種別',
        aligh: 'left',
        sortale: true,
        value: 'type'
      }, {
        text: '価格',
        aligh: 'right',
        sortale: true,
        value: 'cost'
      }, {
        text: '支払者',
        aligh: 'right',
        sortale: false,
        value: 'payment'
      }],
      pagination: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 10
      },

      openInput: false,
      yearFilter: '',
      monthFilter: '',
      dayFilter: '',
      searched: [],
      selectedDay: 'All Data in List'
    };
  },
  props: ['items'],
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_2__homebookChart___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__Modal___default.a,
    inputDialog: __WEBPACK_IMPORTED_MODULE_4__parts_CostInput___default.a
  },
  filters: {
    costFilter: function costFilter(value) {
      var formatter = new Intl.NumberFormat('ja-JP');
      return '\xA5 ' + formatter.format(value);
    }
  },
  methods: {
    setdateFormat: function setdateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).format('YYYY年MM月DD日');
    },
    setTypeJp: function setTypeJp(type) {
      return typeTable[type];
    },
    clearFilter: function clearFilter() {
      this.yearFilter = '';
      this.monthFilter = '';
      this.dayFilter = '';
      this.itemFilter();
    },
    itemFilter: function itemFilter() {
      if (!this.yearFilter) {
        this.searched = this.items;
        return;
      }
      var inputFilter = this.yearFilter;
      if (this.monthFilter) {
        inputFilter += '-' + this.monthFilter;
      }
      if (this.dayFilter) {
        inputFilter += '-' + this.dayFilter;
      }
      this.searched = this.items.filter(function (item) {
        return item.date.indexOf(String(inputFilter)) > -1;
      });
    }
  },
  created: function created() {
    this.searched = this.items;
    this.isLoading = true;
  },

  watch: {
    items: function items() {
      this.searched = this.items;

      this.isLoading = !(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.items).length > 0);
    },
    yearFilter: function yearFilter() {
      if (!this.yearFilter) {
        this.monthFilter = '';
      }
      this.itemFilter();
    },
    monthFilter: function monthFilter() {
      if (!this.monthFilter) {
        this.dayFilter = '';
      }
      this.itemFilter();
    },
    dayFilter: function dayFilter() {
      this.itemFilter();
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: ['show', 'modalColor'],
  data: function data() {
    return {
      showModal: false
    };
  },
  methods: {
    modalControl: function modalControl(state) {
      this.showModal = state;
    }
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Video',
  data: function data() {
    return {
      playerOptions: {
        start: 0,
        playsinline: false,

        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0, 2.5, 3.0, 8.0],
        sources: [{
          type: 'video/mp4',
          src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.playerOptions.muted = false;
    }, 2000);
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    onPlayerEnded: function onPlayerEnded(player) {},
    onPlayerLoadeddata: function onPlayerLoadeddata(player) {},
    onPlayerWaiting: function onPlayerWaiting(player) {},
    onPlayerPlaying: function onPlayerPlaying(player) {},
    onPlayerTimeupdate: function onPlayerTimeupdate(player) {},
    onPlayerCanplay: function onPlayerCanplay(player) {},
    onPlayerCanplaythrough: function onPlayerCanplaythrough(player) {},
    playerStateChanged: function playerStateChanged(playerCurrentState) {},
    playerReadied: function playerReadied(player) {}
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_charts_doughnutChart_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_charts_lineChart_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_charts_holizontalBarChart_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_charts_calcChart_js__ = __webpack_require__(257);





var colorList = ['rgba(186, 0, 0, 0.5)', 'rgba(129, 255, 4, 0.5)', 'rgba(255, 0, 0, 0.5)', 'rgba(109, 0, 180, 0.5)', 'rgba(0, 56, 255, 0.5)', 'rgba(255, 252, 0, 0.5)', 'rgba(0, 0, 0, 0.5)', 'rgba(181, 31, 255, 0.5)', 'rgba(129, 176, 152, 0.5)', 'rgba(47, 105, 65, 0.5)'];





var calc = new __WEBPACK_IMPORTED_MODULE_6__lib_charts_calcChart_js__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  data: function data() {
    return {
      type_list: null,
      allGenreDonuts: null,
      paymentRate: null,
      paymentCosts_Hajime: null,
      paymentCosts_Shiori: null,
      totalCosts: []
    };
  },
  props: ['data', 'isLoading'],
  components: {
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_3__lib_charts_doughnutChart_js__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_4__lib_charts_lineChart_js__["a" /* default */],
    HolizontalBar: __WEBPACK_IMPORTED_MODULE_5__lib_charts_holizontalBarChart_js__["a" /* default */]
  },
  filters: {
    en: function en(val) {
      var formatter = new Intl.NumberFormat('ja-JP');
      return '\xA5 ' + formatter.format(val);
    }
  },
  methods: {
    checkObjectValueExist: function checkObjectValueExist(arr, key, val) {
      return arr.some(function (arrVal) {
        return val === arrVal[key];
      });
    },
    setDayObj: function setDayObj() {
      var obj = {};
      var data = this.data;
      for (var key in data) {
        var dates = data[key].date;
        var date = dates.split('-');
        if (date[0] in obj) {
          if (!this.checkObjectValueExist(obj[date[0]], 'date', date[1])) {
            obj[date[0]].push({
              date: date[1],
              value: date[0] + '-' + date[1]
            });
          }
        } else {
          obj[date[0]] = [{
            date: date[1],
            value: date[0] + '-' + date[1]
          }];
        }
      }
      this.dayObj = obj;
    },
    getDateString: function getDateString(year, month, day) {
      return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    },
    createCalcResult: function createCalcResult() {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      var costs = {
        Hajime: 0,
        Shiori: 0
      };
      for (var key in data) {
        costs[data[key].payment] += Math.round(Number(data[key].cost) / 2);
        if (data[key].type === 'rent') {
          costs[data[key].payment] -= 30000;
        }
      }
      this.shareCosts = costs.Hajime - costs.Shiori;
      return null;
    },
    fillData: function fillData() {
      this.setAllGenreDonuts();
      this.setPaymentRate();
      this.setDailyCosts();
      this.createCalcResult();
      this.setPaymentCosts('Hajime');
      this.setPaymentCosts('Shiori');
    },
    setAllGenreDonuts: function setAllGenreDonuts() {
      var labels = [];
      var datas = {};
      var costs = 0;
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      for (var key in data) {
        costs += Math.round(Number(data[key].cost));
        if (labels.indexOf(String(data[key].type)) < 0) {
          labels.push(data[key].type);
          datas[data[key].type] = Math.round(Number(data[key].cost));
        } else {
          datas[data[key].type] += Math.round(Number(data[key].cost));
        }
      }
      data = [];
      for (var dkey in datas) {
        data.push(datas[dkey]);
      }

      this.totalCost = costs;
      this.allGenreDonuts = {
        labels: labels,
        datasets: [{
          label: 'donuts',
          backgroundColor: colorList,
          data: data
        }]
      };
      return this.allGenreDonuts;
    },
    setPaymentRate: function setPaymentRate() {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      var labels = [];
      var datas = {};
      for (var key in data) {
        if (labels.indexOf(String(data[key].payment)) < 0) {
          labels.push(data[key].payment);
          datas[data[key].payment] = Math.round(Number(data[key].cost));
        } else {
          datas[data[key].payment] += Math.round(Number(data[key].cost));
        }
      }
      var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(datas);

      this.paymentRate = {
        labels: labels,
        datasets: [{
          label: 'Payment Rate',
          backgroundColor: colorList,
          data: result
        }]
      };
      return this.paymentRate;
    },
    setDailyCosts: function setDailyCosts() {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      var types = ['ALL'];
      var days = [];
      var datas = {
        'ALL': []
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (k) {
        days.push(data[k].date);
      });
      var dayRange = days.filter(function (x, i, self) {
        return self.indexOf(x) === i;
      });
      dayRange = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], calc.sortFunc(dayRange));
      var startDate = dayRange[0];
      var endDate = dayRange[dayRange.length - 1];
      dayRange = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], calc.getAllDay(startDate, endDate));
      dayRange = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], calc.sortFunc(dayRange));
      for (var key in data) {
        if (types.indexOf(String(data[key].type)) < 0) {
          types.push(data[key].type);
          datas[data[key].type] = [];
        }
      }
      for (var i = 0; i < dayRange.length; i++) {
        for (var j = 0; j < types.length; j++) {
          var cost = 0;
          for (var _key in data) {
            if (dayRange[i] === data[_key].date && types[j] === data[_key].type) {
              cost += Number(data[_key].cost);
            }
          }
          datas[types[j]].push(cost);
        }
      }
      var all = [];
      for (var _i = 0; _i < dayRange.length; _i++) {
        var allCost = 0;
        for (var _j = 0; _j < types.length; _j++) {
          allCost += datas[types[_j]][_i];
        }
        all.push(allCost);
      }
      datas.ALL = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], all);
      var datasets = [];
      for (var _i2 in types) {
        var dataset = {
          label: types[_i2],
          backgroundColor: colorList[_i2],
          data: datas[types[_i2]]
        };
        datasets.push(dataset);
      }
      this.dailyCosts = {
        labels: dayRange,
        datasets: datasets
      };

      return datasets;
    },
    setPaymentCosts: function setPaymentCosts(payment) {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      var types = [];
      var datas = [];
      var costs = 0;
      for (var key in data) {
        if (String(data[key].payment) === payment) {
          costs += Math.round(Number(data[key].cost));
          if (types.indexOf(String(data[key].type)) < 0) {
            types.push(data[key].type);
            datas[data[key].type] = Number(data[key].cost);
          } else {
            datas[data[key].type] += Number(data[key].cost);
          }
        }
      }

      var result = {
        labels: types,
        datasets: [{
          label: payment + ' 支払い割合',
          backgroundColor: colorList,
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(datas)
        }]
      };
      this.totalCosts[payment] = costs;
      payment === 'Hajime' ? this.paymentCosts_Hajime = result : this.paymentCosts_Shiori = result;
      return result;
    }
  },
  created: function created() {
    this.this.dayObj = calc.setDayObj(this.data);
    this.fillData();
  },

  watch: {
    data: function data() {
      this.fillData();
    }
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_login__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_Auth__ = __webpack_require__(75);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-menu',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_3__parts_login___default.a
  },
  data: function data() {
    return {
      menuVisible: false,
      drawer: null,
      items: [{ title: 'Home', icon: 'home', routers: '/', isAuth: false }, { title: '音声入力メモ', icon: 'mic', routers: '/memo', isAuth: true }, { title: '健康チェク', icon: 'directions_walk', routers: '/helth', isAuth: true }, { title: '家計簿', icon: 'attach_money', routers: '/house', isAuth: true }, { title: 'KPT', icon: 'loop', routers: '/kpt', isAuth: true }, { title: 'Video', icon: 'video_library', routers: '/video-player', isAuth: true }],
      mini: false,
      right: null,
      showLogin: false,
      showLogout: false,
      Auth: null,
      user: {},
      isLogin: false,
      newAuth: {
        'mail': '',
        'password': ''
      },
      authUser: '',
      authIsLogin: false,
      authLoading: true,
      loginState: false,

      position: 'center',
      duration: 4000,
      isInfinity: false
    };
  },
  methods: {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.Auth.login(_this.newAuth.mail, _this.newAuth.password);

              case 2:
                if (!_context.sent) {
                  _context.next = 8;
                  break;
                }

                _this.showSnackbar('success', 'ログインに成功しました');
                _this.showLogin = false;
                _this.setAuthInfo();
                _context.next = 9;
                break;

              case 8:
                _this.showSnackbar('error', 'ログインに失敗しました');

              case 9:
                _this.newAuth = {
                  'mail': '',
                  'password': ''
                };

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    logout: function logout() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.Auth.logout();

              case 2:
                if (!_context2.sent) {
                  _context2.next = 8;
                  break;
                }

                _this2.showSnackbar('success', 'ログアウトしました');
                _this2.showLogout = false;
                _this2.setAuthInfo();
                _context2.next = 9;
                break;

              case 8:
                _this2.showSnackbar('error', 'ログアウトに失敗しました');

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setAuthInfo: function setAuthInfo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_4__lib_Auth__["a" /* default */]();

              case 2:
                _this3.Auth = _context3.sent;

                if (_this3.Auth.isLoading) {
                  setTimeout(function () {
                    _this3.Auth.getUser().then(function (res) {
                      _this3.user = res;
                      _this3.isLogin = Boolean(res);
                      _this3.authLoading = false;
                    });
                  }, 3000);
                } else {
                  _this3.Auth.getUser().then(function (res) {
                    _this3.user = res;
                    _this3.isLogin = Boolean(res);
                    _this3.authLoading = false;
                  });
                }
                return _context3.abrupt('return');

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showMenueItem: function showMenueItem(authShow) {
      return authShow ? this.isLogin : true;
    },
    showSnackbar: function showSnackbar(type, message) {
      this.$emit('snack', type, message);
    }
  },
  mounted: function mounted() {
    this.setAuthInfo();
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebaseEnv_json__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebaseEnv_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebaseEnv_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chart_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Health',
  data: function data() {
    return {
      chartData: {
        labels: ['Item 1', 'Item 2', 'Item 3'],
        datasets: [{
          label: 'Component 1',
          backgroundColor: 'rgb(114, 213, 207)',
          data: [15, 20, 30]
        }, {
          label: 'Component 2',
          backgroundColor: 'rgb(238, 86, 86)',
          data: [20, 30, 40]
        }]
      },
      fireDB: '',
      weightDB: {},
      weightData: {},
      today: '',
      weight: '',
      hoge: ''
    };
  },
  components: {
    VueChart: __WEBPACK_IMPORTED_MODULE_2_vue_chart_js___default.a
  },
  methods: {
    pushData: function pushData(event) {
      var weightObj = {
        date: this.today,
        weight: Number(this.weight)
      };
      this.hoge = weightObj;
      this.weightDB.push(weightObj);
    },
    syncFirebase: function syncFirebase() {
      var listObj = [];
      this.weightDB.on('child_added', function (fbdata) {
        listObj.push(fbdata.val());
      });
      this.weightData = listObj;
    },
    setDate: function setDate(now) {
      var month = (now.getMonth() + 1 > 9 ? '' : '0') + (now.getMonth() + 1);
      var date = (now.getDate() > 9 ? '' : '0') + now.getDate();
      this.today = now.getFullYear() + '-' + month + '-' + date;
    }
  },
  created: function created() {
    var _this = this;

    var that = this;
    this.fireDB = !__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.app.length ? __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_1__firebaseEnv_json___default.a) : __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.app();
    this.weightDB = this.fireDB.database().ref('weights');
    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.syncFirebase();
      } else {
        alert('ログインしてね♪');
        that.$router.push('/');
      }
    });

    var now = new Date();
    this.setDate(now);
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      windowHeight: window.innerHeight
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function () {
        _this.windowHeight = window.innerHeight;
      });
    });
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CostTable__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CostTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CostTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HouseHold',
  data: function data() {
    return {
      fireDB: '',
      costDB: '',
      costData: {}
    };
  },
  components: {
    CostTable: __WEBPACK_IMPORTED_MODULE_2__components_CostTable___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal___default.a
  },
  methods: {
    syncFirebase: function syncFirebase() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var listObj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                listObj = [];
                _context.next = 3;
                return _this.costDB.on('child_added', function (fbdata) {
                  var data = fbdata.val();
                  data.fbKey = fbdata.key;
                  listObj.push(data);
                });

              case 3:
                _this.costData = listObj;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    this.fireDB = !__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.app.length ? __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json___default.a) : __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.app();
    this.costDB = this.fireDB.database().ref('costs');
    this.syncFirebase();
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KPT',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  components: {
    VoiceInput: __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput___default.a
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      voiceInput: {
        message: ''
      }
    };
  },
  components: {
    VoiceInput: __WEBPACK_IMPORTED_MODULE_0__parts_VoiceInput___default.a
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Video__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Video__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoPlayer',
  data: function data() {
    return {
      msg: 'aaa'
    };
  },

  components: {
    Video: __WEBPACK_IMPORTED_MODULE_0__components_Video___default.a
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_Auth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Modal__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableSearch',
  data: function data() {
    return {
      Auth: null,
      fireDB: null,
      costDB: null,
      input: [],
      inputError: [],
      rules: {
        required: function required(value) {
          return !!value || '必須入力です';
        },
        cost: function cost(value) {
          return Math.round(value) === Number(value) && value > 0 || '0より大きい整数を入力してください';
        }
      },
      types: [{ 'val': 'utility', 'label': '光熱費' }, { 'val': 'foods', 'label': '食費' }, { 'val': 'Sundries', 'label': '雑貨' }, { 'val': 'rent', 'label': '家賃' }],
      payments: ['Hajime', 'Shiori'],
      dataConst: {
        'date': __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('YYYY-MM-DD'),
        'showDate': false,
        'dateTmp': __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('YYYY-MM-DD'),
        'cost': null,
        'type': 'foods'
      },
      modalView: {
        'save': false,
        'error': false
      }
    };
  },
  props: ['openInput'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_Modal___default.a
  },
  methods: {
    setPayment: function setPayment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_6__lib_Auth__["a" /* default */]();

              case 2:
                _this.Auth = _context.sent;

                if (_this.Auth.isLoading) {
                  setTimeout(function () {
                    _this.Auth.getUser().then(function (res) {
                      _this.dataConst.payment = res.user;
                      _this.input[0].payment = res.user;
                    });
                  }, 3000);
                } else {
                  _this.Auth.getUser().then(function (res) {
                    _this.dataConst.payment = res.user;
                    _this.input[0].payment = res.user;
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkSaveData: function checkSaveData() {
      var result = true;
      var error = [];
      var typeList = this.types.map(function (obj) {
        return obj.val;
      });
      if (!this.input.length) result = false;
      this.input.forEach(function (obj, key) {
        if (!obj.date) {
          error.push({ 'key': key, 'message': '支払日の値が入力されていません' });
          result = false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_3_moment___default()(obj.date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()))) {
          error.push({ 'key': key, 'message': '支払日は本日を含む過去のデータのみ登録できます' });
          result = false;
        }
        if (!obj.type) {
          error.push({ 'key': key, 'message': '購入種別が入力されていません' });
          result = false;
        }
        if (!typeList.includes(obj.type)) {
          error.push({ 'key': key, 'message': '未知の購入種別が指定されています' });
          result = false;
        }
        if (!obj.cost) {
          error.push({ 'key': key, 'message': '金額が入力されていません' });
          result = false;
        }
        if (!obj.payment) {
          error.push({ 'key': key, 'message': '購入者が入力されていません' });
          result = false;
        }
      });
      if (result) {
        this.modalView.save = true;
      } else {
        this.inputError = error;
        this.modalView.error = true;
      }
    },
    setDateInput: function setDateInput(item, key) {
      this.input[key].date = String(this.input[key].dateTmp);
      this.input[key].showDate = false;
    },
    saveData: function saveData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.input.forEach(function (data) {
                  delete data.showDate;
                  delete data.dateTmp;
                  _this2.costDB.push(data);
                  console.log('Saved Data:', data);
                });

              case 2:
                _this2.modalView.save = false;
                _this2.close();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.input = [];
      this.addInput();
      this.$emit('close');
    },
    addInput: function addInput() {
      this.input.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.dataConst));
    },
    deleteInput: function deleteInput(index) {
      this.input.splice(index, 1);
    }
  },
  computed: {
    computedDataFormat: function computedDataFormat() {
      return this.dataConst.date ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dataConst.date).format('YYYY-MM-DD') : '';
    }
  },
  mounted: function mounted() {
    this.setPayment();
    this.addInput();
    this.fireDB = !__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.app.length ? __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_5__firebaseEnv_json___default.a) : __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.app();
    this.costDB = this.fireDB.database().ref('costs');
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'voice_input',
  data: function data() {
    return {
      recognition: new (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)(),
      recognitionText: 'Start Voice Input'
    };
  },
  props: ['voiceInput'],
  methods: {
    startInput: function startInput() {
      this.recognition.start();
    }
  },
  created: function created() {
    var _this = this;

    this.recognition.onstart = function () {
      _this.recognitionText = 'ニュウリョクチュウ...';
    };
    this.recognition.onend = function () {
      _this.recognitionText = 'Start Voice Input';
    };
    this.recognition.onresult = function (event) {
      if (event.results.length > 0) {
        _this.voiceInput.message = event.results[0][0].transcript;
      }
    };
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      valid: false,
      emailRules: [function (v) {
        return !!v || 'Emailは必須入力です';
      }, function (v) {
        return (/.+@.+/.test(v) || 'Emailの形式にしてください'
        );
      }],
      passowordRules: [function (v) {
        return !!v || 'Passwordは必須入力です';
      }]
    };
  },
  props: ['auth'],
  methods: {
    login: function login() {
      this.setSnack(__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.mail, this.password).then(function () {
        return { 'msg': 'ログインに成功しました。' };
      }).catch(function (error) {
        return { 'msg': 'ログインに失敗しました。ERROR_CODE: ' + error.code };
      }));
      this.colseModal();
    },
    colseModal: function colseModal() {
      this.$emit('close', false);
    },
    setSnack: function setSnack(msg) {
      for (var key in msg) {
        if (msg[key] instanceof Object && 'msg' in msg[key]) {
          return this.$emit('snack', msg[key].msg);
        }
      }
    }
  }
});

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 102,
	"./af.js": 102,
	"./ar": 109,
	"./ar-dz": 103,
	"./ar-dz.js": 103,
	"./ar-kw": 104,
	"./ar-kw.js": 104,
	"./ar-ly": 105,
	"./ar-ly.js": 105,
	"./ar-ma": 106,
	"./ar-ma.js": 106,
	"./ar-sa": 107,
	"./ar-sa.js": 107,
	"./ar-tn": 108,
	"./ar-tn.js": 108,
	"./ar.js": 109,
	"./az": 110,
	"./az.js": 110,
	"./be": 111,
	"./be.js": 111,
	"./bg": 112,
	"./bg.js": 112,
	"./bm": 113,
	"./bm.js": 113,
	"./bn": 114,
	"./bn.js": 114,
	"./bo": 115,
	"./bo.js": 115,
	"./br": 116,
	"./br.js": 116,
	"./bs": 117,
	"./bs.js": 117,
	"./ca": 118,
	"./ca.js": 118,
	"./cs": 119,
	"./cs.js": 119,
	"./cv": 120,
	"./cv.js": 120,
	"./cy": 121,
	"./cy.js": 121,
	"./da": 122,
	"./da.js": 122,
	"./de": 125,
	"./de-at": 123,
	"./de-at.js": 123,
	"./de-ch": 124,
	"./de-ch.js": 124,
	"./de.js": 125,
	"./dv": 126,
	"./dv.js": 126,
	"./el": 127,
	"./el.js": 127,
	"./en-au": 128,
	"./en-au.js": 128,
	"./en-ca": 129,
	"./en-ca.js": 129,
	"./en-gb": 130,
	"./en-gb.js": 130,
	"./en-ie": 131,
	"./en-ie.js": 131,
	"./en-il": 132,
	"./en-il.js": 132,
	"./en-nz": 133,
	"./en-nz.js": 133,
	"./eo": 134,
	"./eo.js": 134,
	"./es": 137,
	"./es-do": 135,
	"./es-do.js": 135,
	"./es-us": 136,
	"./es-us.js": 136,
	"./es.js": 137,
	"./et": 138,
	"./et.js": 138,
	"./eu": 139,
	"./eu.js": 139,
	"./fa": 140,
	"./fa.js": 140,
	"./fi": 141,
	"./fi.js": 141,
	"./fo": 142,
	"./fo.js": 142,
	"./fr": 145,
	"./fr-ca": 143,
	"./fr-ca.js": 143,
	"./fr-ch": 144,
	"./fr-ch.js": 144,
	"./fr.js": 145,
	"./fy": 146,
	"./fy.js": 146,
	"./gd": 147,
	"./gd.js": 147,
	"./gl": 148,
	"./gl.js": 148,
	"./gom-latn": 149,
	"./gom-latn.js": 149,
	"./gu": 150,
	"./gu.js": 150,
	"./he": 151,
	"./he.js": 151,
	"./hi": 152,
	"./hi.js": 152,
	"./hr": 153,
	"./hr.js": 153,
	"./hu": 154,
	"./hu.js": 154,
	"./hy-am": 155,
	"./hy-am.js": 155,
	"./id": 156,
	"./id.js": 156,
	"./is": 157,
	"./is.js": 157,
	"./it": 158,
	"./it.js": 158,
	"./ja": 159,
	"./ja.js": 159,
	"./jv": 160,
	"./jv.js": 160,
	"./ka": 161,
	"./ka.js": 161,
	"./kk": 162,
	"./kk.js": 162,
	"./km": 163,
	"./km.js": 163,
	"./kn": 164,
	"./kn.js": 164,
	"./ko": 165,
	"./ko.js": 165,
	"./ku": 166,
	"./ku.js": 166,
	"./ky": 167,
	"./ky.js": 167,
	"./lb": 168,
	"./lb.js": 168,
	"./lo": 169,
	"./lo.js": 169,
	"./lt": 170,
	"./lt.js": 170,
	"./lv": 171,
	"./lv.js": 171,
	"./me": 172,
	"./me.js": 172,
	"./mi": 173,
	"./mi.js": 173,
	"./mk": 174,
	"./mk.js": 174,
	"./ml": 175,
	"./ml.js": 175,
	"./mn": 176,
	"./mn.js": 176,
	"./mr": 177,
	"./mr.js": 177,
	"./ms": 179,
	"./ms-my": 178,
	"./ms-my.js": 178,
	"./ms.js": 179,
	"./mt": 180,
	"./mt.js": 180,
	"./my": 181,
	"./my.js": 181,
	"./nb": 182,
	"./nb.js": 182,
	"./ne": 183,
	"./ne.js": 183,
	"./nl": 185,
	"./nl-be": 184,
	"./nl-be.js": 184,
	"./nl.js": 185,
	"./nn": 186,
	"./nn.js": 186,
	"./pa-in": 187,
	"./pa-in.js": 187,
	"./pl": 188,
	"./pl.js": 188,
	"./pt": 190,
	"./pt-br": 189,
	"./pt-br.js": 189,
	"./pt.js": 190,
	"./ro": 191,
	"./ro.js": 191,
	"./ru": 192,
	"./ru.js": 192,
	"./sd": 193,
	"./sd.js": 193,
	"./se": 194,
	"./se.js": 194,
	"./si": 195,
	"./si.js": 195,
	"./sk": 196,
	"./sk.js": 196,
	"./sl": 197,
	"./sl.js": 197,
	"./sq": 198,
	"./sq.js": 198,
	"./sr": 200,
	"./sr-cyrl": 199,
	"./sr-cyrl.js": 199,
	"./sr.js": 200,
	"./ss": 201,
	"./ss.js": 201,
	"./sv": 202,
	"./sv.js": 202,
	"./sw": 203,
	"./sw.js": 203,
	"./ta": 204,
	"./ta.js": 204,
	"./te": 205,
	"./te.js": 205,
	"./tet": 206,
	"./tet.js": 206,
	"./tg": 207,
	"./tg.js": 207,
	"./th": 208,
	"./th.js": 208,
	"./tl-ph": 209,
	"./tl-ph.js": 209,
	"./tlh": 210,
	"./tlh.js": 210,
	"./tr": 211,
	"./tr.js": 211,
	"./tzl": 212,
	"./tzl.js": 212,
	"./tzm": 214,
	"./tzm-latn": 213,
	"./tzm-latn.js": 213,
	"./tzm.js": 214,
	"./ug-cn": 215,
	"./ug-cn.js": 215,
	"./uk": 216,
	"./uk.js": 216,
	"./ur": 217,
	"./ur.js": 217,
	"./uz": 219,
	"./uz-latn": 218,
	"./uz-latn.js": 218,
	"./uz.js": 219,
	"./vi": 220,
	"./vi.js": 220,
	"./x-pseudo": 221,
	"./x-pseudo.js": 221,
	"./yo": 222,
	"./yo.js": 222,
	"./zh-cn": 223,
	"./zh-cn.js": 223,
	"./zh-hk": 224,
	"./zh-hk.js": 224,
	"./zh-tw": 225,
	"./zh-tw.js": 225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 390;

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HajimeToolsHome.a5ecf1e.jpg";

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Kirby.8e3222b.png";

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h2s.69c0ce9.png";

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = {"apiKey":"AIzaSyDYGu8enSh6x7tnDJAVvj6QkBJNJu1ADs0","authDomain":"hajime-tools.firebaseapp.com","databaseURL":"https://hajime-tools.firebaseio.com","projectId":"hajime-tools","storageBucket":"hajime-tools.appspot.com","messagingSenderId":861806036049}

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s2h.7a7e1cb.png";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  "data-v-450fbc66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-6a2ba1ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  "data-v-3ede0de5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-54cfa1a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-05807514",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-010aebfa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-f2fae0fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-ecd324c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-61b894ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Video"
  }, [_c('md-card', [_c('md-card-actions', {
    directives: [{
      name: "md-ink-ripple",
      rawName: "v-md-ink-ripple"
    }]
  }, [_c('div', {
    staticClass: "md-subhead"
  }, [_c('span', [_vm._v("Base Config / サンプル")])])]), _vm._v(" "), _c('md-card-media', [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    },
    on: {
      "play": function($event) {
        _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        _vm.onPlayerPause($event)
      },
      "ended": function($event) {
        _vm.onPlayerEnded($event)
      },
      "loadeddata": function($event) {
        _vm.onPlayerLoadeddata($event)
      },
      "waiting": function($event) {
        _vm.onPlayerWaiting($event)
      },
      "playing": function($event) {
        _vm.onPlayerPlaying($event)
      },
      "timeupdate": function($event) {
        _vm.onPlayerTimeupdate($event)
      },
      "canplay": function($event) {
        _vm.onPlayerCanplay($event)
      },
      "canplaythrough": function($event) {
        _vm.onPlayerCanplaythrough($event)
      },
      "ready": _vm.playerReadied,
      "statechanged": function($event) {
        _vm.playerStateChanged($event)
      }
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memo"
  }, [_c('h1', [_vm._v("音声入力メモ")]), _vm._v(" "), _c('voice-input', {
    attrs: {
      "voiceInput": _vm.voiceInput
    },
    on: {
      "update:voiceInput": function($event) {
        _vm.voiceInput = $event
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("「" + _vm._s(_vm.voiceInput.message) + "」")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "KPT"
  }, [_c('h1', [_vm._v("KPT")]), _vm._v(" "), _c('VoiceInput')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('v-parallax', {
    attrs: {
      "height": _vm.windowHeight,
      "dark": "",
      "src": __webpack_require__(397)
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "column": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    staticClass: "hometitle"
  }, [_vm._v("Hajime-Tools")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('vue-menu', {
    on: {
      "snack": _vm.setSnackbar
    }
  }, [_c('div', {
    attrs: {
      "slot": "main-container"
    },
    slot: "main-container"
  }, [_c('router-view', {
    staticClass: "main-content"
  })], 1)]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout,
      "multi-line": "",
      "bottom": "",
      "right": ""
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarMessage) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSnackbar = false
      }
    }
  }, [_vm._v("\n        閉じる\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalContents"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    class: _vm.modalColor,
    attrs: {
      "dark": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('v-card-text', [_vm._t("contents")], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _vm._t("action")], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Health"
  }, [_c('h1', [_vm._v("タイジューケー")]), _vm._v(" "), _c('md-field', [_c('label', [_vm._v("ニュウリョク")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.weight),
      callback: function($$v) {
        _vm.weight = $$v
      },
      expression: "weight"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.pushData()
      }
    }
  }, [_vm._v("トーロク")]), _vm._v(" "), _c('vue-chart', {
    attrs: {
      "type": "line",
      "data": _vm.chartData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input-dialog', {
    attrs: {
      "openInput": _vm.openInput
    },
    on: {
      "close": function($event) {
        _vm.openInput = false
      }
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n      家計簿リスト\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "round": "",
      "color": "teal accent-4"
    },
    on: {
      "click": function($event) {
        _vm.openInput = true
      }
    },
    slot: "activator"
  }, [_vm._v("\n        新規登録\n      ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "2017",
      "label": "日付フィルタ(年)"
    },
    model: {
      value: (_vm.yearFilter),
      callback: function($$v) {
        _vm.yearFilter = $$v
      },
      expression: "yearFilter"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yearFilter),
      expression: "yearFilter"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "12",
      "label": "(月)"
    },
    model: {
      value: (_vm.monthFilter),
      callback: function($$v) {
        _vm.monthFilter = $$v
      },
      expression: "monthFilter"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monthFilter),
      expression: "monthFilter"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "31",
      "label": "(日)"
    },
    model: {
      value: (_vm.dayFilter),
      callback: function($$v) {
        _vm.dayFilter = $$v
      },
      expression: "dayFilter"
    }
  }), _vm._v(" "), (_vm.yearFilter) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "pink darken-1"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("\n        Clear\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.searched,
      "loading": _vm.isLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('h3', [_vm._v(_vm._s(_vm.setdateFormat(props.item.date)))])]), _vm._v(" "), _c('td', [_c('h3', [_vm._v(_vm._s(_vm.setTypeJp(props.item.type)))])]), _vm._v(" "), _c('td', [_c('h3', [_vm._v(_vm._s(_vm._f("costFilter")(props.item.cost)))])]), _vm._v(" "), _c('td', [_c('h3', [_vm._v(_vm._s(props.item.payment))])])]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "color": "blue",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1), _vm._v(" "), _c('chart', {
    attrs: {
      "data": _vm.searched,
      "isLoading": _vm.isLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HouseHold"
  }, [_c('cost-table', {
    attrs: {
      "items": _vm.costData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.auth.mail),
      callback: function($$v) {
        _vm.$set(_vm.auth, "mail", $$v)
      },
      expression: "auth.mail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "パスワード",
      "type": 'password',
      "rules": _vm.passowordRules,
      "required": ""
    },
    model: {
      value: (_vm.auth.password),
      callback: function($$v) {
        _vm.$set(_vm.auth, "password", $$v)
      },
      expression: "auth.password"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('div', [_c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v("全体支払割合")]), _vm._v(" "), _c('DoughnutChart', {
    attrs: {
      "width": 210,
      "height": 70,
      "chart-data": _vm.allGenreDonuts
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm._f("en")(_vm.totalCost)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v("支払い者割合")]), _vm._v(" "), _c('HolizontalBar', {
    attrs: {
      "width": 210,
      "height": 70,
      "chart-data": _vm.paymentRate
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v("支出日グラフ")]), _vm._v(" "), _c('LineChart', {
    attrs: {
      "width": 420,
      "height": 70,
      "chart-data": _vm.dailyCosts
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Hajime")]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_vm._v("支出者別支払割合")]), _vm._v(" "), _c('DoughnutChart', {
    attrs: {
      "width": 210,
      "height": 100,
      "chart-data": _vm.paymentCosts_Hajime
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm._f("en")(_vm.totalCosts.Hajime)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [(_vm.shareCosts < 0) ? _c('v-img', {
    attrs: {
      "src": __webpack_require__(399),
      "aspect-ratio": "1",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm._f("en")(Math.abs(_vm.shareCosts))))]), _vm._v(" "), (_vm.shareCosts > 0) ? _c('v-img', {
    attrs: {
      "src": __webpack_require__(400),
      "aspect-ratio": "1",
      "contain": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Shiori")]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_vm._v("支出者別支払割合(Shiori)")]), _vm._v(" "), _c('DoughnutChart', {
    attrs: {
      "width": 210,
      "height": 100,
      "chart-data": _vm.paymentCosts_Shiori
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm._f("en")(_vm.totalCosts.Shiori)))])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-menu"
  }, [_c('div', {
    staticClass: "hide-overflow",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "absolute": "",
      "color": "indigo",
      "dark": "",
      "scroll-off-screen": "",
      "scroll-target": "#main-container"
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('h2', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("Hajime Tools")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLogin) ? _c('v-btn', {
    attrs: {
      "loading": _vm.authLoading,
      "small": "",
      "round": "",
      "color": "teal accent-4"
    },
    on: {
      "click": function($event) {
        _vm.showLogin = true
      }
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")]), _vm._v("\n        ログイン\n      ")], 1) : (_vm.isLogin) ? _c('v-toolbar-title', [_c('h3', [_vm._v(_vm._s(((_vm.user.user) + " [" + (_vm.user.email) + "]")))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "color": "pink darken-1"
    },
    on: {
      "click": function($event) {
        _vm.showLogout = true
      }
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v("\n        ログアウト\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-y",
    staticStyle: {
      "max-height": "100vh",
      "padding-top": "60px !important"
    },
    attrs: {
      "id": "scrolling-techniques"
    }
  }, [_c('v-container', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_vm._t("main-container", null, {
    id: "main-container"
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "mini-variant": _vm.mini,
      "absolute": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-1"
  }, [(_vm.mini) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": __webpack_require__(398)
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Hajime-Tools")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {}
      }
    }, [(_vm.showMenueItem(item.isAuth)) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenueItem(item.isAuth)) ? _c('v-list-tile-content', [_c('router-link', {
      attrs: {
        "to": item.routers,
        "tag": "v-list-tile-title"
      }
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e()], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showLogin,
      "modalColor": "blue lighten-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('login', {
    attrs: {
      "slot": "contents",
      "auth": _vm.newAuth
    },
    on: {
      "update:auth": function($event) {
        _vm.newAuth = $event
      }
    },
    slot: "contents"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "flat": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogin = false
      }
    }
  }, [_vm._v("モドル")])], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showLogout,
      "modalColor": "pink darken-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "contents"
    },
    slot: "contents"
  }, [_c('h2', [_vm._v("本当にHajime-Toolからログアウトしますか?")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "flat": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogout = false
      }
    }
  }, [_vm._v("キャンセル")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "voice_input"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.recognitionText
    },
    model: {
      value: (_vm.voiceInput.message),
      callback: function($$v) {
        _vm.$set(_vm.voiceInput, "message", $$v)
      },
      expression: "voiceInput.message"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "color": "cyan darken-2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startInput($event)
      }
    }
  }, [_c('v-icon', [_vm._v("\n      mic\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js vjs-custom-skin"
  })])
}]}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.openInput),
      callback: function($$v) {
        _vm.openInput = $$v
      },
      expression: "openInput"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "indigo"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("新規登録")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": _vm.checkSaveData
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-around": ""
    }
  }, [_vm._l((_vm.input), function(item, key) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md1": "",
        "offset-sm1": "",
        "offset-md1": ""
      }
    }, [_c('h3', [_vm._v(_vm._s(("【" + (Number(key) + 1) + "】")))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md2": ""
      }
    }, [_c('v-menu', {
      ref: "dateInput",
      refInFor: true,
      attrs: {
        "close-on-content-click": false,
        "full-width": "",
        "max-width": "290"
      },
      model: {
        value: (item.showDate),
        callback: function($$v) {
          _vm.$set(item, "showDate", $$v)
        },
        expression: "item.showDate"
      }
    }, [_c('v-text-field', {
      attrs: {
        "slot": "activator",
        "value": _vm.computedDataFormat,
        "clearable": "",
        "append-icon": "event",
        "label": "支払日",
        "box": "",
        "rules": [_vm.rules.required],
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (item.dateTmp),
        callback: function($$v) {
          _vm.$set(item, "dateTmp", $$v)
        },
        expression: "item.dateTmp"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "color": "indigo"
      },
      on: {
        "change": function($event) {
          _vm.setDateInput(item, key)
        }
      },
      model: {
        value: (item.dateTmp),
        callback: function($$v) {
          _vm.$set(item, "dateTmp", $$v)
        },
        expression: "item.dateTmp"
      }
    })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.types,
        "item-text": "label",
        "item-value": "val",
        "label": "購入種別",
        "box": "",
        "bottom": "",
        "rules": [_vm.rules.required],
        "clearable": ""
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "box": "",
        "rules": [_vm.rules.required, _vm.rules.cost],
        "label": "価格",
        "append-icon": "¥",
        "clearable": ""
      },
      model: {
        value: (item.cost),
        callback: function($$v) {
          _vm.$set(item, "cost", $$v)
        },
        expression: "item.cost"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.payments,
        "label": "購入者",
        "box": "",
        "rules": [_vm.rules.required],
        "clearable": ""
      },
      model: {
        value: (item.payment),
        callback: function($$v) {
          _vm.$set(item, "payment", $$v)
        },
        expression: "item.payment"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sx12": "",
        "sm1": "",
        "dm1": ""
      }
    }, [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.input.length > 1),
        expression: "input.length > 1"
      }],
      attrs: {
        "icon": "",
        "dark": "",
        "small": "",
        "feb": "",
        "color": "pink darken-1"
      },
      on: {
        "click": function($event) {
          _vm.deleteInput(key)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (Number(key) + 1 == _vm.input.length),
        expression: "Number(key) + 1 == input.length"
      }],
      attrs: {
        "icon": "",
        "dark": "",
        "small": "",
        "feb": "",
        "color": "teal accent-4"
      },
      on: {
        "click": _vm.addInput
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]
  })], 2), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalView.save,
      "modalColor": "blue lighten-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("保存データ確認")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "contents"
    },
    slot: "contents"
  }, [_vm._v("\n              " + _vm._s(((_vm.input.length) + "個のデータを保存します")) + "\n            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "flat": ""
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.modalView.save = false
      }
    }
  }, [_vm._v("キャンセル")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalView.error,
      "modalColor": "pink darken-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("入力エラー")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "contents"
    },
    slot: "contents"
  }, [_c('h2', [_vm._v(_vm._s(((_vm.inputError.length) + "個のデータに入力ミスがあります")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sx3": "",
      "sm3": "",
      "md3": ""
    }
  }, [_c('h4', [_vm._v("【対象ID】")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sx9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('h4', [_vm._v("【エラー内容】")])]), _vm._v(" "), _vm._l((_vm.inputError), function(item, key) {
    return [_c('v-flex', {
      attrs: {
        "sx3": "",
        "sm3": "",
        "md3": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(("【" + (Number(item.key) + 1) + "】")))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sx9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_vm._v(_vm._s(item.message))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sx12": "",
        "sm12": "",
        "md12": ""
      }
    }, [_c('v-divider', {
      key: key,
      staticClass: "grey--text text--lighten-4",
      attrs: {
        "inset": ""
      }
    })], 1)]
  })], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "round": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.modalView.error = false
      }
    }
  }, [_vm._v("閉じる")])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('h1', [_vm._v("ビデオプレーヤー")]), _vm._v(" "), _c('Video')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports = {"Play":"تشغيل","Pause":"ايقاف","Current Time":"الوقت الحالي","Duration Time":"Dauer","Remaining Time":"الوقت المتبقي","Stream Type":"نوع التيار","LIVE":"مباشر","Loaded":"تم التحميل","Progress":"التقدم","Fullscreen":"ملء الشاشة","Non-Fullscreen":"غير ملء الشاشة","Mute":"صامت","Unmute":"غير الصامت","Playback Rate":"معدل التشغيل","Subtitles":"الترجمة","subtitles off":"ايقاف الترجمة","Captions":"التعليقات","captions off":"ايقاف التعليقات","Chapters":"فصول","You aborted the media playback":"لقد ألغيت تشغيل الفيديو","A network error caused the media download to fail part-way.":"تسبب خطأ في الشبكة بفشل تحميل الفيديو بالكامل.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"لا يمكن تحميل الفيديو بسبب فشل في الخادم أو الشبكة ، أو فشل بسبب عدم امكانية قراءة تنسيق الفيديو.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"تم ايقاف تشغيل الفيديو بسبب مشكلة فساد أو لأن الفيديو المستخدم يستخدم ميزات غير مدعومة من متصفحك.","No compatible source was found for this media.":"فشل العثور على أي مصدر متوافق مع هذا الفيديو.","Play Video":"تشغيل الفيديو","Close":"أغلق","Modal Window":"نافذة مشروطة","This is a modal window":"هذه نافذة مشروطة","This modal can be closed by pressing the Escape key or activating the close button.":"يمكن غلق هذه النافذة المشروطة عن طريق الضغط على زر الخروج أو تفعيل زر الإغلاق",", opens captions settings dialog":", تفتح نافذة  خيارات التعليقات",", opens subtitles settings dialog":", تفتح نافذة  خيارات الترجمة",", selected":", مختار"}

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports = {"Play":"Възпроизвеждане","Pause":"Пауза","Current Time":"Текущо време","Duration Time":"Продължителност","Remaining Time":"Оставащо време","Stream Type":"Тип на потока","LIVE":"НА ЖИВО","Loaded":"Заредено","Progress":"Прогрес","Fullscreen":"Цял екран","Non-Fullscreen":"Спиране на цял екран","Mute":"Без звук","Unmute":"Със звук","Playback Rate":"Скорост на възпроизвеждане","Subtitles":"Субтитри","subtitles off":"Спряни субтитри","Captions":"Аудио надписи","captions off":"Спряни аудио надписи","Chapters":"Глави","You aborted the media playback":"Спряхте възпроизвеждането на видеото","A network error caused the media download to fail part-way.":"Грешка в мрежата провали изтеглянето на видеото.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Видеото не може да бъде заредено заради проблем със сървъра или мрежата или защото този формат не е поддържан.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Възпроизвеждането на видеото беше прекъснато заради проблем с файла или защото видеото използва опции които браузърът Ви не поддържа.","No compatible source was found for this media.":"Не беше намерен съвместим източник за това видео."}

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

module.exports = {"Play":"Reproducció","Pause":"Pausa","Current Time":"Temps reproduït","Duration Time":"Durada total","Remaining Time":"Temps restant","Stream Type":"Tipus de seqüència","LIVE":"EN DIRECTE","Loaded":"Carregat","Progress":"Progrés","Fullscreen":"Pantalla completa","Non-Fullscreen":"Pantalla no completa","Mute":"Silencia","Unmute":"Amb so","Playback Rate":"Velocitat de reproducció","Subtitles":"Subtítols","subtitles off":"Subtítols desactivats","Captions":"Llegendes","captions off":"Llegendes desactivades","Chapters":"Capítols","You aborted the media playback":"Heu interromput la reproducció del vídeo.","A network error caused the media download to fail part-way.":"Un error de la xarxa ha interromput la baixada del vídeo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"No s'ha pogut carregar el vídeo perquè el servidor o la xarxa han fallat, o bé perquè el seu format no és compatible.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La reproducció de vídeo s'ha interrumput per un problema de corrupció de dades o bé perquè el vídeo demanava funcions que el vostre navegador no ofereix.","No compatible source was found for this media.":"No s'ha trobat cap font compatible amb el vídeo."}

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

module.exports = {"Play":"Přehrát","Pause":"Pauza","Current Time":"Aktuální čas","Duration Time":"Doba trvání","Remaining Time":"Zbývající čas","Stream Type":"Stream Type","LIVE":"ŽIVĚ","Loaded":"Načteno","Progress":"Stav","Fullscreen":"Celá obrazovka","Non-Fullscreen":"Zmenšená obrazovka","Mute":"Ztlumit zvuk","Unmute":"Přehrát zvuk","Playback Rate":"Rychlost přehrávání","Subtitles":"Titulky","subtitles off":"Titulky vypnuty","Captions":"Popisky","captions off":"Popisky vypnuty","Chapters":"Kapitoly","You aborted the media playback":"Přehrávání videa je přerušeno.","A network error caused the media download to fail part-way.":"Video nemohlo být načteno, kvůli chybě v síti.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video nemohlo být načteno, buď kvůli chybě serveru nebo sítě nebo proto, že daný formát není podporován.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Váš prohlížeč nepodporuje formát videa.","No compatible source was found for this media.":"Špatně zadaný zdroj videa."}

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

module.exports = {"Play":"Afspil","Pause":"Pause","Current Time":"Aktuel tid","Duration Time":"Varighed","Remaining Time":"Resterende tid","Stream Type":"Stream-type","LIVE":"LIVE","Loaded":"Indlæst","Progress":"Status","Fullscreen":"Fuldskærm","Non-Fullscreen":"Luk fuldskærm","Mute":"Uden lyd","Unmute":"Med lyd","Playback Rate":"Afspilningsrate","Subtitles":"Undertekster","subtitles off":"Uden undertekster","Captions":"Undertekster for hørehæmmede","captions off":"Uden undertekster for hørehæmmede","Chapters":"Kapitler","You aborted the media playback":"Du afbrød videoafspilningen.","A network error caused the media download to fail part-way.":"En netværksfejl fik download af videoen til at fejle.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikke indlæses, enten fordi serveren eller netværket fejlede, eller fordi formatet ikke er understøttet.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoafspilningen blev afbrudt på grund af ødelagte data eller fordi videoen benyttede faciliteter som din browser ikke understøtter.","No compatible source was found for this media.":"Fandt ikke en kompatibel kilde for denne media."}

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports = {"Play":"Wiedergabe","Pause":"Pause","Current Time":"Aktueller Zeitpunkt","Duration Time":"Dauer","Remaining Time":"Verbleibende Zeit","Stream Type":"Streamtyp","LIVE":"LIVE","Loaded":"Geladen","Progress":"Status","Fullscreen":"Vollbild","Non-Fullscreen":"Kein Vollbild","Mute":"Ton aus","Unmute":"Ton ein","Playback Rate":"Wiedergabegeschwindigkeit","Subtitles":"Untertitel","subtitles off":"Untertitel aus","Captions":"Untertitel","captions off":"Untertitel aus","Chapters":"Kapitel","You aborted the media playback":"Sie haben die Videowiedergabe abgebrochen.","A network error caused the media download to fail part-way.":"Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.","No compatible source was found for this media.":"Für dieses Video wurde keine kompatible Quelle gefunden.","Play Video":"Video abspielen","Close":"Schließen","Modal Window":"Modales Fenster","This is a modal window":"Dies ist ein modales Fenster","This modal can be closed by pressing the Escape key or activating the close button.":"Durch Drücken der Esc-Taste bzw. Betätigung der Schaltfläche \"Schließen\" wird dieses modale Fenster geschlossen.",", opens captions settings dialog":", öffnet Einstellungen für Untertitel",", opens subtitles settings dialog":", öffnet Einstellungen für Untertitel",", selected":", ausgewählt","Close Modal Dialog":"Modales Fenster schließen","Descriptions":"Beschreibungen","descriptions off":"Beschreibungen aus","The media is encrypted and we do not have the keys to decrypt it.":"Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",", opens descriptions settings dialog":", öffnet Einstellungen für Beschreibungen","Audio Track":"Tonspur"}

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

module.exports = {"Play":"Aναπαραγωγή","Pause":"Παύση","Current Time":"Τρέχων χρόνος","Duration Time":"Συνολικός χρόνος","Remaining Time":"Υπολοιπόμενος χρόνος","Stream Type":"Τύπος ροής","LIVE":"ΖΩΝΤΑΝΑ","Loaded":"Φόρτωση επιτυχής","Progress":"Πρόοδος","Fullscreen":"Πλήρης οθόνη","Non-Fullscreen":"Έξοδος από πλήρη οθόνη","Mute":"Σίγαση","Unmute":"Kατάργηση σίγασης","Playback Rate":"Ρυθμός αναπαραγωγής","Subtitles":"Υπότιτλοι","subtitles off":"απόκρυψη υπότιτλων","Captions":"Λεζάντες","captions off":"απόκρυψη λεζάντων","Chapters":"Κεφάλαια","Close Modal Dialog":"Κλείσιμο παραθύρου","Descriptions":"Περιγραφές","descriptions off":"απόκρυψη περιγραφών","Audio Track":"Ροή ήχου","You aborted the media playback":"Ακυρώσατε την αναπαραγωγή","A network error caused the media download to fail part-way.":"Ένα σφάλμα δικτύου προκάλεσε την αποτυχία μεταφόρτωσης του αρχείου προς αναπαραγωγή.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Το αρχείο προς αναπαραγωγή δεν ήταν δυνατό να φορτωθεί είτε γιατί υπήρξε σφάλμα στον διακομιστή ή το δίκτυο, είτε γιατί ο τύπος του αρχείου δεν υποστηρίζεται.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Η αναπαραγωγή ακυρώθηκε είτε λόγω κατεστραμμένου αρχείου, είτε γιατί το αρχείο απαιτεί λειτουργίες που δεν υποστηρίζονται από το πρόγραμμα περιήγησης που χρησιμοποιείτε.","No compatible source was found for this media.":"Δεν βρέθηκε συμβατή πηγή αναπαραγωγής για το συγκεκριμένο αρχείο.","The media is encrypted and we do not have the keys to decrypt it.":"Το αρχείο προς αναπαραγωγή είναι κρυπτογραφημένo και δεν υπάρχουν τα απαραίτητα κλειδιά αποκρυπτογράφησης.","Play Video":"Αναπαραγωγή βίντεο","Close":"Κλείσιμο","Modal Window":"Aναδυόμενο παράθυρο","This is a modal window":"Το παρών είναι ένα αναδυόμενο παράθυρο","This modal can be closed by pressing the Escape key or activating the close button.":"Αυτό το παράθυρο μπορεί να εξαφανιστεί πατώντας το πλήκτρο Escape ή πατώντας το κουμπί κλεισίματος.",", opens captions settings dialog":", εμφανίζει τις ρυθμίσεις για τις λεζάντες",", opens subtitles settings dialog":", εμφανίζει τις ρυθμίσεις για τους υπότιτλους",", opens descriptions settings dialog":", εμφανίζει τις ρυθμίσεις για τις περιγραφές",", selected":", επιλεγμένο"}

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports = {"Play":"Play","Pause":"Pause","Current Time":"Current Time","Duration Time":"Duration Time","Remaining Time":"Remaining Time","Stream Type":"Stream Type","LIVE":"LIVE","Loaded":"Loaded","Progress":"Progress","Fullscreen":"Fullscreen","Non-Fullscreen":"Non-Fullscreen","Mute":"Mute","Unmute":"Unmute","Playback Rate":"Playback Rate","Subtitles":"Subtitles","subtitles off":"subtitles off","Captions":"Captions","captions off":"captions off","Chapters":"Chapters","Close Modal Dialog":"Close Modal Dialog","Descriptions":"Descriptions","descriptions off":"descriptions off","Audio Track":"Audio Track","You aborted the media playback":"You aborted the media playback","A network error caused the media download to fail part-way.":"A network error caused the media download to fail part-way.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"The media could not be loaded, either because the server or network failed or because the format is not supported.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.","No compatible source was found for this media.":"No compatible source was found for this media.","The media is encrypted and we do not have the keys to decrypt it.":"The media is encrypted and we do not have the keys to decrypt it.","Play Video":"Play Video","Close":"Close","Modal Window":"Modal Window","This is a modal window":"This is a modal window","This modal can be closed by pressing the Escape key or activating the close button.":"This modal can be closed by pressing the Escape key or activating the close button.",", opens captions settings dialog":", opens captions settings dialog",", opens subtitles settings dialog":", opens subtitles settings dialog",", opens descriptions settings dialog":", opens descriptions settings dialog",", selected":", selected"}

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

module.exports = {"Play":"Reproducción","Pause":"Pausa","Current Time":"Tiempo reproducido","Duration Time":"Duración total","Remaining Time":"Tiempo restante","Stream Type":"Tipo de secuencia","LIVE":"DIRECTO","Loaded":"Cargado","Progress":"Progreso","Fullscreen":"Pantalla completa","Non-Fullscreen":"Pantalla no completa","Mute":"Silenciar","Unmute":"No silenciado","Playback Rate":"Velocidad de reproducción","Subtitles":"Subtítulos","subtitles off":"Subtítulos desactivados","Captions":"Subtítulos especiales","captions off":"Subtítulos especiales desactivados","Chapters":"Capítulos","You aborted the media playback":"Ha interrumpido la reproducción del vídeo.","A network error caused the media download to fail part-way.":"Un error de red ha interrumpido la descarga del vídeo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.","No compatible source was found for this media.":"No se ha encontrado ninguna fuente compatible con este vídeo."}

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

module.exports = {"Play":"پخش","Pause":"وقفه","Current Time":"زمان کنونی","Duration Time":"مدت زمان","Remaining Time":"زمان باقیمانده","Stream Type":"نوع استریم","LIVE":"زنده","Loaded":"فراخوانی شده","Progress":"پیشرفت","Fullscreen":"تمام صفحه","Non-Fullscreen":"نمایش عادی","Mute":"بی صدا","Unmute":"بهمراه صدا","Playback Rate":"سرعت پخش","Subtitles":"زیرنویس","subtitles off":"بدون زیرنویس","Captions":"عنوان","captions off":"بدون عنوان","Chapters":"فصل","You aborted the media playback":"شما پخش را متوقف کردید.","A network error caused the media download to fail part-way.":"مشکل در دریافت ویدئو ...","The media could not be loaded, either because the server or network failed or because the format is not supported.":"فرمت پشتیبانی نمیشود یا خطایی روی داده است.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"مشکل در دریافت ویدئو ...","No compatible source was found for this media.":"هیچ ورودی ای برای این رسانه شناسایی نشد."}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports = {"Play":"Toisto","Pause":"Tauko","Current Time":"Tämänhetkinen aika","Duration Time":"Kokonaisaika","Remaining Time":"Jäljellä oleva aika","Stream Type":"Lähetystyyppi","LIVE":"LIVE","Loaded":"Ladattu","Progress":"Edistyminen","Fullscreen":"Koko näyttö","Non-Fullscreen":"Koko näyttö pois","Mute":"Ääni pois","Unmute":"Ääni päällä","Playback Rate":"Toistonopeus","Subtitles":"Tekstitys","subtitles off":"Tekstitys pois","Captions":"Tekstitys","captions off":"Tekstitys pois","Chapters":"Kappaleet","You aborted the media playback":"Olet keskeyttänyt videotoiston.","A network error caused the media download to fail part-way.":"Verkkovirhe keskeytti videon latauksen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videon lataus ei onnistunut joko palvelin- tai verkkovirheestä tai väärästä formaatista johtuen.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videon toisto keskeytyi, koska media on vaurioitunut tai käyttää käyttää toimintoja, joita selaimesi ei tue.","No compatible source was found for this media.":"Tälle videolle ei löytynyt yhteensopivaa lähdettä."}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports = {"Play":"Lecture","Pause":"Pause","Current Time":"Temps actuel","Duration Time":"Durée","Remaining Time":"Temps restant","Stream Type":"Type de flux","LIVE":"EN DIRECT","Loaded":"Chargé","Progress":"Progression","Fullscreen":"Plein écran","Non-Fullscreen":"Fenêtré","Mute":"Sourdine","Unmute":"Son activé","Playback Rate":"Vitesse de lecture","Subtitles":"Sous-titres","subtitles off":"Sous-titres désactivés","Captions":"Sous-titres transcrits","captions off":"Sous-titres transcrits désactivés","Chapters":"Chapitres","Close Modal Dialog":"Fermer la boîte de dialogue modale","Descriptions":"Descriptions","descriptions off":"descriptions désactivées","Audio Track":"Piste audio","You aborted the media playback":"Vous avez interrompu la lecture de la vidéo.","A network error caused the media download to fail part-way.":"Une erreur de réseau a interrompu le téléchargement de la vidéo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Cette vidéo n'a pas pu être chargée, soit parce que le serveur ou le réseau a échoué ou parce que le format n'est pas reconnu.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La lecture de la vidéo a été interrompue à cause d'un problème de corruption ou parce que la vidéo utilise des fonctionnalités non prises en charge par votre navigateur.","No compatible source was found for this media.":"Aucune source compatible n'a été trouvée pour cette vidéo.","The media is encrypted and we do not have the keys to decrypt it.":"Le média est chiffré et nous n'avons pas les clés pour le déchiffrer.","Play Video":"Lire la vidéo","Close":"Fermer","Modal Window":"Fenêtre modale","This is a modal window":"Ceci est une fenêtre modale","This modal can be closed by pressing the Escape key or activating the close button.":"Ce modal peut être fermé en appuyant sur la touche Échap ou activer le bouton de fermeture.",", opens captions settings dialog":", ouvrir les paramètres des sous-titres transcrits",", opens subtitles settings dialog":", ouvrir les paramètres des sous-titres",", opens descriptions settings dialog":", ouvrir les paramètres des descriptions",", selected":", sélectionné"}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports = {"Play":"Pusti","Pause":"Pauza","Current Time":"Trenutno vrijeme","Duration Time":"Vrijeme trajanja","Remaining Time":"Preostalo vrijeme","Stream Type":"Način strimovanja","LIVE":"UŽIVO","Loaded":"Učitan","Progress":"Progres","Fullscreen":"Puni ekran","Non-Fullscreen":"Mali ekran","Mute":"Prigušen","Unmute":"Ne-prigušen","Playback Rate":"Stopa reprodukcije","Subtitles":"Podnaslov","subtitles off":"Podnaslov deaktiviran","Captions":"Titlovi","captions off":"Titlovi deaktivirani","Chapters":"Poglavlja","You aborted the media playback":"Isključili ste reprodukciju videa.","A network error caused the media download to fail part-way.":"Video se prestao preuzimati zbog greške na mreži.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.","No compatible source was found for this media.":"Nije nađen nijedan kompatibilan izvor ovog videa."}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports = {"Play":"Lejátszás","Pause":"Szünet","Current Time":"Aktuális időpont","Duration Time":"Hossz","Remaining Time":"Hátralévő idő","Stream Type":"Adatfolyam típusa","LIVE":"ÉLŐ","Loaded":"Betöltve","Progress":"Állapot","Fullscreen":"Teljes képernyő","Non-Fullscreen":"Normál méret","Mute":"Némítás","Unmute":"Némítás kikapcsolva","Playback Rate":"Lejátszási sebesség","Subtitles":"Feliratok","subtitles off":"Feliratok kikapcsolva","Captions":"Magyarázó szöveg","captions off":"Magyarázó szöveg kikapcsolva","Chapters":"Fejezetek","You aborted the media playback":"Leállította a lejátszást","A network error caused the media download to fail part-way.":"Hálózati hiba miatt a videó részlegesen töltődött le.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"A videó nem tölthető be hálózati vagy kiszolgálói hiba miatt, vagy a formátuma nem támogatott.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"A lejátszás adatsérülés miatt leállt, vagy a videó egyes tulajdonságait a böngészője nem támogatja.","No compatible source was found for this media.":"Nincs kompatibilis forrás ehhez a videóhoz."}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports = {"Play":"Play","Pause":"Pausa","Current Time":"Orario attuale","Duration Time":"Durata","Remaining Time":"Tempo rimanente","Stream Type":"Tipo del Streaming","LIVE":"LIVE","Loaded":"Caricato","Progress":"Stato","Fullscreen":"Schermo intero","Non-Fullscreen":"Chiudi schermo intero","Mute":"Muto","Unmute":"Audio","Playback Rate":"Tasso di riproduzione","Subtitles":"Sottotitoli","subtitles off":"Senza sottotitoli","Captions":"Sottotitoli non udenti","captions off":"Senza sottotitoli non udenti","Chapters":"Capitolo","You aborted the media playback":"La riproduzione del filmato è stata interrotta.","A network error caused the media download to fail part-way.":"Il download del filmato è stato interrotto a causa di un problema rete.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.","No compatible source was found for this media.":"Non ci sono fonti compatibili per questo filmato."}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports = {"Play":"再生","Pause":"一時停止","Current Time":"現在の時間","Duration Time":"長さ","Remaining Time":"残りの時間","Stream Type":"ストリームの種類","LIVE":"ライブ","Loaded":"ロード済み","Progress":"進行状況","Fullscreen":"フルスクリーン","Non-Fullscreen":"フルスクリーン以外","Mute":"ミュート","Unmute":"ミュート解除","Playback Rate":"再生レート","Subtitles":"サブタイトル","subtitles off":"サブタイトル オフ","Captions":"キャプション","captions off":"キャプション オフ","Chapters":"チャプター","You aborted the media playback":"動画再生を中止しました","A network error caused the media download to fail part-way.":"ネットワーク エラーにより動画のダウンロードが途中で失敗しました","The media could not be loaded, either because the server or network failed or because the format is not supported.":"サーバーまたはネットワークのエラー、またはフォーマットがサポートされていないため、動画をロードできませんでした","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"破損の問題、またはお使いのブラウザがサポートしていない機能が動画に使用されていたため、動画の再生が中止されました","No compatible source was found for this media.":"この動画に対して互換性のあるソースが見つかりませんでした"}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports = {"Play":"재생","Pause":"일시중지","Current Time":"현재 시간","Duration Time":"지정 기간","Remaining Time":"남은 시간","Stream Type":"스트리밍 유형","LIVE":"라이브","Loaded":"로드됨","Progress":"진행","Fullscreen":"전체 화면","Non-Fullscreen":"전체 화면 해제","Mute":"음소거","Unmute":"음소거 해제","Playback Rate":"재생 비율","Subtitles":"서브타이틀","subtitles off":"서브타이틀 끄기","Captions":"자막","captions off":"자막 끄기","Chapters":"챕터","You aborted the media playback":"비디오 재생을 취소했습니다.","A network error caused the media download to fail part-way.":"네트워크 오류로 인하여 비디오 일부를 다운로드하지 못 했습니다.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"비디오를 로드할 수 없습니다. 서버 혹은 네트워크 오류 때문이거나 지원되지 않는 형식 때문일 수 있습니다.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"비디오 재생이 취소됐습니다. 비디오가 손상되었거나 비디오가 사용하는 기능을 브라우저에서 지원하지 않는 것 같습니다.","No compatible source was found for this media.":"비디오에 호환되지 않는 소스가 있습니다."}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports = {"Play":"Spill","Pause":"Pause","Current Time":"Aktuell tid","Duration Time":"Varighet","Remaining Time":"Gjenstående tid","Stream Type":"Type strøm","LIVE":"DIREKTE","Loaded":"Lastet inn","Progress":"Status","Fullscreen":"Fullskjerm","Non-Fullscreen":"Lukk fullskjerm","Mute":"Lyd av","Unmute":"Lyd på","Playback Rate":"Avspillingsrate","Subtitles":"Undertekst på","subtitles off":"Undertekst av","Captions":"Undertekst for hørselshemmede på","captions off":"Undertekst for hørselshemmede av","Chapters":"Kapitler","You aborted the media playback":"Du avbrøt avspillingen.","A network error caused the media download to fail part-way.":"En nettverksfeil avbrøt nedlasting av videoen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikke lastes ned, på grunn av nettverksfeil eller serverfeil, eller fordi formatet ikke er støttet.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoavspillingen ble avbrudt på grunn av ødelagte data eller fordi videoen ville gjøre noe som nettleseren din ikke har støtte for.","No compatible source was found for this media.":"Fant ikke en kompatibel kilde for dette mediainnholdet."}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports = {"Play":"Afspelen","Pause":"Pauze","Current Time":"Huidige tijd","Duration Time":"Looptijd","Remaining Time":"Resterende tijd","Stream Type":"Streamtype","LIVE":"LIVE","Loaded":"Geladen","Progress":"Status","Fullscreen":"Volledig scherm","Non-Fullscreen":"Geen volledig scherm","Mute":"Geluid uit","Unmute":"Geluid aan","Playback Rate":"Weergavesnelheid","Subtitles":"Ondertiteling","subtitles off":"ondertiteling uit","Captions":"Bijschriften","captions off":"bijschriften uit","Chapters":"Hoofdstukken","Descriptions":"Beschrijvingen","descriptions off":"beschrijvingen off","You aborted the media playback":"U hebt de mediaweergave afgebroken.","A network error caused the media download to fail part-way.":"De mediadownload is mislukt door een netwerkfout.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"De media kon niet worden geladen, vanwege een server- of netwerkfout of doordat het formaat niet wordt ondersteund.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"De mediaweergave is afgebroken vanwege beschadigde data of het mediabestand gebruikt functies die niet door uw browser worden ondersteund.","No compatible source was found for this media.":"Voor deze media is geen ondersteunde bron gevonden.","Play Video":"Video Afspelen","Close":"Sluiten","Modal Window":"Modal Venster","This is a modal window":"Dit is een modaal venster","This modal can be closed by pressing the Escape key or activating the close button.":"Dit modaal venster kan gesloten worden door op Escape te drukken of de 'sluiten' knop te activeren.",", opens captions settings dialog":", opent bijschriften instellingen venster",", opens subtitles settings dialog":", opent ondertiteling instellingen venster",", opens descriptions settings dialog":", opent beschrijvingen instellingen venster",", selected":", selected"}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports = {"Play":"Spel","Pause":"Pause","Current Time":"Aktuell tid","Duration Time":"Varigheit","Remaining Time":"Tid attende","Stream Type":"Type straum","LIVE":"DIREKTE","Loaded":"Lasta inn","Progress":"Status","Fullscreen":"Fullskjerm","Non-Fullscreen":"Stenga fullskjerm","Mute":"Ljod av","Unmute":"Ljod på","Playback Rate":"Avspelingsrate","Subtitles":"Teksting på","subtitles off":"Teksting av","Captions":"Teksting for høyrselshemma på","captions off":"Teksting for høyrselshemma av","Chapters":"Kapitel","You aborted the media playback":"Du avbraut avspelinga.","A network error caused the media download to fail part-way.":"Ein nettverksfeil avbraut nedlasting av videoen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikkje lastas ned, på grunn av ein nettverksfeil eller serverfeil, eller av di formatet ikkje er stoda.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoavspelinga blei broten på grunn av øydelagde data eller av di videoen ville gjera noe som nettlesaren din ikkje stodar.","No compatible source was found for this media.":"Fant ikke en kompatibel kilde for dette mediainnholdet."}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports = {"Play":"Odtwarzaj","Pause":"Pauza","Current Time":"Aktualny czas","Duration Time":"Czas trwania","Remaining Time":"Pozostały czas","Stream Type":"Typ strumienia","LIVE":"NA ŻYWO","Loaded":"Załadowany","Progress":"Status","Fullscreen":"Pełny ekran","Non-Fullscreen":"Pełny ekran niedostępny","Mute":"Wyłącz dźwięk","Unmute":"Włącz dźwięk","Playback Rate":"Szybkość odtwarzania","Subtitles":"Napisy","subtitles off":"Napisy wyłączone","Captions":"Transkrypcja","captions off":"Transkrypcja wyłączona","Chapters":"Rozdziały","You aborted the media playback":"Odtwarzanie zostało przerwane","A network error caused the media download to fail part-way.":"Problemy z siecią spowodowały błąd przy pobieraniu materiału wideo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Materiał wideo nie może być załadowany, ponieważ wystąpił problem z siecią lub format nie jest obsługiwany","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Odtwarzanie materiału wideo zostało przerwane z powodu uszkodzonego pliku wideo lub z powodu błędu funkcji, które nie są wspierane przez przeglądarkę.","No compatible source was found for this media.":"Dla tego materiału wideo nie znaleziono kompatybilnego źródła.","Play video":"Odtwarzaj wideo","Close":"Zamknij","Modal Window":"Okno Modala","This is a modal window":"To jest okno modala","This modal can be closed by pressing the Escape key or activating the close button.":"Ten modal możesz zamknąć naciskając przycisk Escape albo wybierając przycisk Zamknij.",", opens captions settings dialog":", otwiera okno dialogowe ustawień transkrypcji",", opens subtitles settings dialog":", otwiera okno dialogowe napisów",", selected":", zaznaczone"}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports = {"Play":"Tocar","Pause":"Pausar","Current Time":"Tempo","Duration Time":"Duração","Remaining Time":"Tempo Restante","Stream Type":"Tipo de Stream","LIVE":"AO VIVO","Loaded":"Carregado","Progress":"Progresso","Fullscreen":"Tela Cheia","Non-Fullscreen":"Tela Normal","Mute":"Mudo","Unmute":"Habilitar Som","Playback Rate":"Velocidade","Subtitles":"Legendas","subtitles off":"Sem Legendas","Captions":"Anotações","captions off":"Sem Anotações","Chapters":"Capítulos","You aborted the media playback":"Você parou a execução do vídeo.","A network error caused the media download to fail part-way.":"Um erro na rede fez o vídeo parar parcialmente.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"O vídeo não pode ser carregado, ou porque houve um problema com sua rede ou pelo formato do vídeo não ser suportado.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"A execução foi interrompida por um problema com o vídeo ou por seu navegador não dar suporte ao seu formato.","No compatible source was found for this media.":"Não foi encontrada fonte de vídeo compatível."}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports = {"Play":"Воспроизвести","Pause":"Приостановить","Current Time":"Текущее время","Duration Time":"Продолжительность","Remaining Time":"Оставшееся время","Stream Type":"Тип потока","LIVE":"ОНЛАЙН","Loaded":"Загрузка","Progress":"Прогресс","Fullscreen":"Полноэкранный режим","Non-Fullscreen":"Неполноэкранный режим","Mute":"Без звука","Unmute":"Со звуком","Playback Rate":"Скорость воспроизведения","Subtitles":"Субтитры","subtitles off":"Субтитры выкл.","Captions":"Подписи","captions off":"Подписи выкл.","Chapters":"Главы","You aborted the media playback":"Вы прервали воспроизведение видео","A network error caused the media download to fail part-way.":"Ошибка сети вызвала сбой во время загрузки видео.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.","No compatible source was found for this media.":"Совместимые источники для этого видео отсутствуют."}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports = {"Play":"Pusti","Pause":"Pauza","Current Time":"Trenutno vrijeme","Duration Time":"Vrijeme trajanja","Remaining Time":"Preostalo vrijeme","Stream Type":"Način strimovanja","LIVE":"UŽIVO","Loaded":"Učitan","Progress":"Progres","Fullscreen":"Puni ekran","Non-Fullscreen":"Mali ekran","Mute":"Prigušen","Unmute":"Ne-prigušen","Playback Rate":"Stopa reprodukcije","Subtitles":"Podnaslov","subtitles off":"Podnaslov deaktiviran","Captions":"Titlovi","captions off":"Titlovi deaktivirani","Chapters":"Poglavlja","You aborted the media playback":"Isključili ste reprodukciju videa.","A network error caused the media download to fail part-way.":"Video se prestao preuzimati zbog greške na mreži.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.","No compatible source was found for this media.":"Nije nađen nijedan kompatibilan izvor ovog videa."}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports = {"Play":"Spela","Pause":"Pausa","Current Time":"Aktuell tid","Duration Time":"Total tid","Remaining Time":"Återstående tid","Stream Type":"Strömningstyp","LIVE":"LIVE","Loaded":"Laddad","Progress":"Förlopp","Fullscreen":"Fullskärm","Non-Fullscreen":"Ej fullskärm","Mute":"Ljud av","Unmute":"Ljud på","Playback Rate":"Uppspelningshastighet","Subtitles":"Text på","subtitles off":"Text av","Captions":"Text på","captions off":"Text av","Chapters":"Kapitel","You aborted the media playback":"Du har avbrutit videouppspelningen.","A network error caused the media download to fail part-way.":"Ett nätverksfel gjorde att nedladdningen av videon avbröts.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Det gick inte att ladda videon, antingen på grund av ett server- eller nätverksfel, eller för att formatet inte stöds.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Uppspelningen avbröts på grund av att videon är skadad, eller också för att videon använder funktioner som din webbläsare inte stöder.","No compatible source was found for this media.":"Det gick inte att hitta någon kompatibel källa för den här videon."}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports = {"Play":"Oynat","Pause":"Duraklat","Current Time":"Süre","Duration Time":"Toplam Süre","Remaining Time":"Kalan Süre","Stream Type":"Yayın Tipi","LIVE":"CANLI","Loaded":"Yüklendi","Progress":"Yükleniyor","Fullscreen":"Tam Ekran","Non-Fullscreen":"Küçük Ekran","Mute":"Ses Kapa","Unmute":"Ses Aç","Playback Rate":"Oynatma Hızı","Subtitles":"Altyazı","subtitles off":"Altyazı Kapalı","Captions":"Ek Açıklamalar","captions off":"Ek Açıklamalar Kapalı","Chapters":"Bölümler","You aborted the media playback":"Video oynatmayı iptal ettiniz","A network error caused the media download to fail part-way.":"Video indirilirken bağlantı sorunu oluştu.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video oynatılamadı, ağ ya da sunucu hatası veya belirtilen format desteklenmiyor.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Tarayıcınız desteklemediği için videoda hata oluştu.","No compatible source was found for this media.":"Video için kaynak bulunamadı.","Play Video":"Videoyu Oynat","Close":"Kapat","Modal Window":"Modal Penceresi","This is a modal window":"Bu bir modal penceresidir","This modal can be closed by pressing the Escape key or activating the close button.":"Bu modal ESC tuşuna basarak ya da kapata tıklanarak kapatılabilir.",", opens captions settings dialog":", ek açıklama ayarları menüsünü açar",", opens subtitles settings dialog":", altyazı ayarları menüsünü açar",", selected":", seçildi"}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports = {"Play":"Відтворити","Pause":"Призупинити","Current Time":"Поточний час","Duration Time":"Тривалість","Remaining Time":"Час, що залишився","Stream Type":"Тип потоку","LIVE":"НАЖИВО","Loaded":"Завантаження","Progress":"Прогрес","Fullscreen":"Повноекранний режим","Non-Fullscreen":"Неповноекранний режим","Mute":"Без звуку","Unmute":"Зі звуком","Playback Rate":"Швидкість відтворення","Subtitles":"Субтитри","subtitles off":"Без субтитрів","Captions":"Підписи","captions off":"Без підписів","Chapters":"Розділи","You aborted the media playback":"Ви припинили відтворення відео","A network error caused the media download to fail part-way.":"Помилка мережі викликала збій під час завантаження відео.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Неможливо завантажити відео через мережевий чи серверний збій або формат не підтримується.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Відтворення відео було припинено через пошкодження або у зв'язку з тим, що відео використовує функції, які не підтримуються вашим браузером.","No compatible source was found for this media.":"Сумісні джерела для цього відео відсутні."}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports = {"Play":"Phát","Pause":"Tạm dừng","Current Time":"Thời gian hiện tại","Duration Time":"Độ dài","Remaining Time":"Thời gian còn lại","Stream Type":"Kiểu Stream","LIVE":"TRỰC TIẾP","Loaded":"Đã tải","Progress":"Tiến trình","Fullscreen":"Toàn màn hình","Non-Fullscreen":"Thoát toàn màn hình","Mute":"Tắt tiếng","Unmute":"Bật âm thanh","Playback Rate":"Tốc độ phát","Subtitles":"Phụ đề","subtitles off":"Tắt phụ đề","Captions":"Chú thích","captions off":"Tắt chú thích","Chapters":"Chương","You aborted the media playback":"Bạn đã hủy việc phát media.","A network error caused the media download to fail part-way.":"Một lỗi mạng dẫn đến việc tải media bị lỗi.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video không tải được, mạng hay server có lỗi hoặc định dạng không được hỗ trợ.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Phát media đã bị hủy do một sai lỗi hoặc media sử dụng những tính năng trình duyệt không hỗ trợ.","No compatible source was found for this media.":"Không có nguồn tương thích cho media này."}

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

module.exports = {"Play":"播放","Pause":"暂停","Current Time":"当前时间","Duration Time":"时长","Remaining Time":"剩余时间","Stream Type":"媒体流类型","LIVE":"直播","Loaded":"加载完毕","Progress":"进度","Fullscreen":"全屏","Non-Fullscreen":"退出全屏","Mute":"静音","Unmute":"取消静音","Playback Rate":"播放码率","Subtitles":"字幕","subtitles off":"字幕关闭","Captions":"内嵌字幕","captions off":"内嵌字幕关闭","Chapters":"节目段落","You aborted the media playback":"视频播放被终止","A network error caused the media download to fail part-way.":"网络错误导致视频下载中途失败。","The media could not be loaded, either because the server or network failed or because the format is not supported.":"视频因格式不支持或者服务器或网络的问题无法加载。","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。","No compatible source was found for this media.":"无法找到此视频兼容的源。","The media is encrypted and we do not have the keys to decrypt it.":"视频已加密，无法解密。"}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports = {"Play":"播放","Pause":"暫停","Current Time":"目前時間","Duration Time":"總共時間","Remaining Time":"剩餘時間","Stream Type":"串流類型","LIVE":"直播","Loaded":"載入完畢","Progress":"進度","Fullscreen":"全螢幕","Non-Fullscreen":"退出全螢幕","Mute":"靜音","Unmute":"取消靜音","Playback Rate":" 播放速率","Subtitles":"字幕","subtitles off":"關閉字幕","Captions":"內嵌字幕","captions off":"關閉內嵌字幕","Chapters":"章節","You aborted the media playback":"影片播放已終止","A network error caused the media download to fail part-way.":"網路錯誤導致影片下載失敗。","The media could not be loaded, either because the server or network failed or because the format is not supported.":"影片因格式不支援或者伺服器或網路的問題無法載入。","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"由於影片檔案損毀或是該影片使用了您的瀏覽器不支援的功能，播放終止。","No compatible source was found for this media.":"無法找到相容此影片的來源。","The media is encrypted and we do not have the keys to decrypt it.":"影片已加密，無法解密。"}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-31b03b92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);





var Auth = function Auth() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Auth);

  this.setUser = function () {
    __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().onAuthStateChanged(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (user) {
                  _this.isLoading = false;
                  _this.authInfo = {
                    'email': user.email,
                    'user': String(user.email).indexOf('3110') > 0 ? 'Hajime' : 'Shiori'
                  };
                } else {
                  _this.authInfo = false;
                  _this.isLoading = false;
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  this.getUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!_this.isLoading) {
              _context2.next = 4;
              break;
            }

            setTimeout(function () {
              return _this.authInfo;
            }, 3000);
            _context2.next = 5;
            break;

          case 4:
            return _context2.abrupt('return', _this.authInfo);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  this.login = function (mail, password) {
    return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signInWithEmailAndPassword(mail, password).then(function (res) {
      return true;
    }).catch(function (err) {
      console.log('ERROR:', err.message);
      return false;
    });
  };

  this.logout = function () {
    return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signOut().then(function () {
      return true;
    }).catch(function (err) {
      console.log('ERROR:', err.message);
      return false;
    });
  };

  this.isLoading = true;
  this.setUser();
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ })

},[261]);


// WEBPACK FOOTER //
// static/js/app.ca4c25d4ec7599b381ef.js